import { useState } from "react";
import { loginWithGoogleApi } from "../api/googleAuthApi";
import useAuth from "./useAuth";
export default function useGoogleAuth() {
    const { login } = useAuth();
    const [loadingGoogle, setLoadingGoogle] = useState(false);
    const [googleError, setGoogleError] = useState("");

    const loginWithGoogle = async (credential) => {
        setLoadingGoogle(true);
        setGoogleError("");

        try {
            const resp = await loginWithGoogleApi(credential);
            login(resp);
            return resp;
        } catch (err) {
            const message = err.message || "Error al iniciar sesión con Google";
            setGoogleError(message);
            throw err;
        } finally {
            setLoadingGoogle(false);
        }
    };

    return {
        loginWithGoogle,
        loadingGoogle,
        googleError,
        setGoogleError,
    };
}